export default "/_next/static/images/f656d6bfb711a59588a8722961db9476.jpg";